import { lazy, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../molecules/layout';
import Loadable from '../elements/Loadable';
import Proposal from "../pages/proposal";
import { getUserInfo } from '../store/actions/auth';

import ScreeningPage from "../pages/screening";
import AppliedJobPage from '../pages/appliedJobs/list';
import CalendarAvailabilityPage from "../pages/calendar";
import CandidateProfile from "../pages/Candidate";
import CandidatePreScreening from "../pages/candidatePreScreening";
import PageNotFound from '../pages/ErrorPages/PageNotFound';
import JobList from "../pages/job";
import JobDetail from "../pages/job/detail";

const Login = Loadable(lazy(() => import("../pages/auth/login")));
const SignUp = Loadable(lazy(() => import("../pages/auth/signup")));
const ForgotPassword = Loadable(lazy(() => import("../pages/auth/forgotPassword")));
const ResetPassword = Loadable(lazy(() => import("../pages/auth/resetPassword")));
const CandidateProfileEditPage = Loadable(lazy(() => import('../pages/Candidate/candidateEditPage')));
const PublicProfile = Loadable(lazy(() => import('../pages/PublicProfile')));

const ProtectedRoute = ({children}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const {userType, userAuthenticated} = useSelector((state) => {
        return {
            userType: state?.auth?.user?.userType,
            userAuthenticated: state?.auth?.accessToken
        }
    });

    useEffect(() => {
        if (!userAuthenticated) {
            navigate('/login')
        } else if (userAuthenticated && !userType) {
            dispatch(getUserInfo())
        }
    }, [userAuthenticated, userType, navigate, dispatch])

    return (<>{children}</>)
}

const RootRedirect = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    
    const {userType, userAuthenticated} = useSelector((state) => {
        return {
            userType: state?.auth?.user?.userType,
            userAuthenticated: state?.auth?.accessToken
        }
    });

    useEffect(() => {
        if (userAuthenticated && !userType) {
            dispatch(getUserInfo())
        }
    }, [userAuthenticated, userType, dispatch])

    useEffect(() => {
        if (userAuthenticated && userType) {
            navigate("/candidate-profile", { replace: true })
        } else if (!userAuthenticated) {
            navigate("/jobs", { replace: true })
        }
    }, [userAuthenticated, userType, navigate])

    return null;
}

const MainRoutes = [
    {
        path: '/login',
        element: <Login/>
    },
    {
        path: '/registration',
        element: <SignUp />
    },
    {
        path: '/forgot-password',
        element: <ForgotPassword />
    },
    {
        path: '/reset-password/:token',
        element: <ResetPassword />
    },
    {
        path: '/404',
        element: <PageNotFound />,
    },
    {
        path: '/proposal/:proposalUuid',
        element: <Proposal/>
    },
    {
        path: '/screening/:screeningUuid',
        element: <ScreeningPage/>
    },
    {
        path: '/calendar/:candidateUuid',
        element: <CalendarAvailabilityPage/>
    },
    {
        path: '/candidate/:candidateId',
        element: <CandidateProfile/>
    },
    {
        path: '/profile/:uuid',
        element: <PublicProfile/>
    },
    {
        path: '/candidate-registration',
        element: <CandidatePreScreening />
    },
    {
        path: '/',
        element: <Layout/>,
        children: [
            {
                path: '/',
                element: <RootRedirect />
            },
            {
                path: 'jobs',
                element: <JobList />
            },
            {
                path: 'jobs/:jobId',
                element: <JobDetail />
            },
            {
                path: 'applied-jobs',
                element: <ProtectedRoute><AppliedJobPage /></ProtectedRoute>
            },
            {
                path: 'candidate-profile',
                element: <ProtectedRoute><CandidateProfileEditPage/></ProtectedRoute>
            },
        ]
    },
];

export default MainRoutes;